import { PropsWithChildren } from "react";
import { NavLink } from "react-router-dom";
import { Icon } from "tabler-icons-react";

import styles from "./side-menu-link.module.css";

export const SideMenuLink = ({
  icon,
  path,
  onClick,
  children,
}: PropsWithChildren<{ icon: Icon; path: string; onClick?: () => void }>) => {
  const Icon = icon;
  return (
    <NavLink to={path} className={styles.link} onClick={onClick}>
      {<Icon size="1.4rem" color="#228BE6" />}
      <span className={styles.title}>{children}</span>
    </NavLink>
  );
};
